import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-services-list-toolbar',
  templateUrl: './list-toolbar.service.component.html',
  styleUrls: ['./list-toolbar.service.component.scss'],
})
export class ServicesListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
